module.exports = {
          srcSet: __webpack_public_path__ + "images/1847-32c79e5bef16539c61b51b9b1c044aad-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1847-e4feda22fb36e1c2be387d7953d594ea-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1847-32c79e5bef16539c61b51b9b1c044aad-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1847-e4feda22fb36e1c2be387d7953d594ea-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1847-32c79e5bef16539c61b51b9b1c044aad-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1847-32c79e5bef16539c61b51b9b1c044aad-320.jpg"},
          
          width: 320,
          height: 251
        }